import React from 'react';
import CircularProgress from 'components/CircularProgress/index';
import { message } from 'antd';
import Auxiliary from 'util/Auxiliary';
import { connect } from 'react-redux';
import { hideMessage } from 'appRedux/actions/Common';
import PropTypes from 'prop-types';

class InfoView extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.error || nextProps.message || nextProps.displayMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 3000);
    }
  }

  render() {
    const { error, loading, displayMessage } = this.props;

    return (
      <Auxiliary>
        {loading && (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
        {displayMessage && message.success(displayMessage)}
        {error && message.error(error)}
      </Auxiliary>
    );
  }
}

InfoView.propTypes = {
  error: PropTypes.string.isRequired,
  message: PropTypes.objectOf(PropTypes.any),
  displayMessage: PropTypes.string.isRequired,
  hideMessage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

InfoView.defaultProps = {
  message: undefined
};

const mapStateToProps = ({ commonData }) => {
  const { error, loading } = commonData;
  const displayMessage = commonData.message;
  return { error, loading, displayMessage };
};

export default connect(mapStateToProps, { hideMessage })(InfoView);
